/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Keep search and desktop navigation from competing for focus and the overlay. */
(function () {
  function closeSearchForNavigation(event) {
    if (!event.target.closest('.Header__MainNav')) return;
    var search = document.getElementById('Search');
    if (search && search.getAttribute('aria-hidden') === 'false') {
      document.body.dispatchEvent(new CustomEvent('search:close', { bubbles: true }));
    }
  }
  document.addEventListener('pointerdown', closeSearchForNavigation, true);
  document.addEventListener('focusin', closeSearchForNavigation, true);
})();

/* Rebind pagination whenever filtering or sorting replaces the product grid. */
document.addEventListener('DOMContentLoaded', function () {
  var collection = document.querySelector('[js-main-collection]');
  if (!collection) return;

  var grid, status, loader, button, wrap;
  var currentPage = 1, firstPage = 1, totalPages = 1, totalItems = 0, pageSize = 0;
  var loading = false, filtering = false, autoLoaded = false;
  var request = null, generation = 0;

  function cancelRequest() {
    generation++;
    if (request) request.abort();
    request = null;
    loading = false;
  }

  function updateUI() {
    var count = grid ? grid.querySelectorAll('.Grid__Cell').length : 0;
    if (status) {
      var first = (firstPage - 1) * pageSize + 1;
      status.textContent = count
        ? 'Showing ' + first + '-' + (first + count - 1) + ' of ' + totalItems + ' products'
        : 'Showing 0 products';
    }
    if (loader) loader.classList.toggle('is-hidden', !loading);
    if (button) {
      button.classList.toggle('is-hidden', !grid || filtering || loading || !autoLoaded || currentPage >= totalPages);
      button.disabled = filtering || loading;
    }
    if (grid) grid.setAttribute('aria-busy', String(filtering || loading));
  }

  function resetPagination() {
    cancelRequest();
    grid = collection.querySelector('.ctm_collection_grid');
    status = collection.querySelector('#collection-status');
    loader = collection.querySelector('#collection-loading');
    button = collection.querySelector('#load-more-btn');
    wrap = collection.querySelector('.CollectionLoadMoreWrap');
    currentPage = grid ? Number(grid.dataset.currentPage) || 1 : 1;
    firstPage = currentPage;
    totalPages = grid ? Number(grid.dataset.totalPage) || 1 : 1;
    totalItems = grid ? Number(grid.dataset.totalItems) || 0 : 0;
    pageSize = grid ? Number(grid.dataset.pageSize) || 0 : 0;
    autoLoaded = currentPage > 1;
    filtering = false;
    updateUI();
    maybeAutoLoad();
  }

  function loadMore() {
    if (!grid || loading || filtering || currentPage >= totalPages) return;
    var activeGrid = grid;
    var activeGeneration = generation;
    var nextPage = currentPage + 1;
    var url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);
    url.searchParams.set('section_id', collection.dataset.sectionId);
    request = new AbortController();
    loading = true;
    updateUI();

    fetch(url.toString(), { signal: request.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load products');
        return response.text();
      })
      .then(function (html) {
        if (activeGeneration !== generation || !activeGrid.isConnected) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('.ctm_collection_grid');
        if (!nextGrid || !nextGrid.children.length) throw new Error('No products returned');
        Array.from(nextGrid.children).forEach(function (node) { activeGrid.appendChild(node); });
        currentPage = nextPage;
        autoLoaded = true;
        var pageURL = new URL(window.location.href);
        pageURL.searchParams.set('page', currentPage);
        history.replaceState(history.state, '', pageURL);
      })
      .catch(function (error) {
        if (activeGeneration !== generation || error.name === 'AbortError') return;
        autoLoaded = true; // Keep a manual retry available after a failed request.
      })
      .finally(function () {
        if (activeGeneration !== generation) return;
        request = null;
        loading = false;
        updateUI();
      });
  }

  function maybeAutoLoad() {
    if (!grid || !wrap || loading || filtering || autoLoaded || currentPage >= totalPages) return;
    if (wrap.getBoundingClientRect().top <= window.innerHeight + 120) {
      autoLoaded = true;
      loadMore();
    }
  }

  collection.addEventListener('click', function (event) {
    if (event.target.closest('#load-more-btn')) loadMore();
  });
  document.addEventListener('collection:loading', function () {
    cancelRequest();
    filtering = true;
    updateUI();
  });
  document.addEventListener('collection:updated', resetPagination);
  window.addEventListener('scroll', maybeAutoLoad, { passive: true });
  window.addEventListener('resize', maybeAutoLoad);
  resetPagination();
});
